import React, {useEffect, useRef, useState} from 'react';
import shareSrc from '../../../assets/images/share.png'

import CloseIconComponent from "../../reusable/CloseIconComponent";
import ExportListTitleComponent from "../ExportListTitleComponent";
import download from '../../../assets/images/download_white.png';
import {doCopyText} from "../../../utils";
import ResizerComponent from "../../reusable/ResizerComponent";
import {ForResizeType} from "../../reusable/ResizerComponent/ResizerComponent";
import './style.scss';
import useClickOutside from "../../../hooks/useClickOutside";
import { useSelector, useDispatch } from 'react-redux';
import { ApplicationState } from '../../../store';
import { LayoutState } from '../../../store/layouts/types';
import { setExportWindowSize } from '../../../store/layouts/actions';

const { CONFIG } = window;


const { ServerAddress, ServerPort } = typeof (CONFIG) !== 'undefined' ? CONFIG : '';

interface Props {
    closeHandler: () => void,
    avilist: any[],
    direction: number,
    setSorting: (key: string) => void,
    type: string,
    shareStatusHandler: (aviId: string) => void
};

const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'divursday', 'Friday', 'Saturday'];

/////////////////// STATUS /////////////////////
interface StatusProps {
    status: number
}

const getSize = (size: number) => {
    let denom = 1;
    let sizeCategory = "Bytes";

    if (size > (1024 * 1024 * 1024)) {
        denom = 1024 * 1024 * 1024;
        sizeCategory = "GB";
    } else if (size > (1024 * 1024)) {
        denom = 1024 * 1024;
        sizeCategory = "MB";
    } else if (size > 1024) {
        denom = 1024;
        sizeCategory = "KB";
    }
    const modifiedSize = size / denom;
    return " ~" + modifiedSize.toPrecision((size > 999) ? 4 : 3) + " " + sizeCategory;
};

const getTimeDuration = (initDuration: number) => {
    const duration = Math.floor(initDuration / 1000);
    const duration_seconds = duration % 60;
    const duration_minutes = Math.floor(duration / 60) % 60;
    const duration_hours = Math.floor(duration / 3600);
    let formatDuration = '';

    if (duration_hours > 0) formatDuration += duration_hours + ((duration_hours > 1) ? "h " : " ");
    if (duration_minutes > 0) formatDuration += duration_minutes + ((duration_minutes >= 1) ? "m " : " ");
    if (duration_seconds > 0) formatDuration += duration_seconds + ((duration_seconds > 1) ? "s" : "");

    return formatDuration
};

const getStatus = (status: number, avi_id: string, statusDetail: string) => {
    // first letter uppercase
    statusDetail = statusDetail.charAt(0).toUpperCase() + statusDetail.slice(1);

    if (status == -2) return <span className='red'  title={statusDetail}> FAILED </span>;
    if (status == -1) return <span title={statusDetail} > QUEUED </span>;
    if (status < 1000) return <span title={statusDetail}>  { (status/ 10) + "%" } </span>;
    const url = `https://${ServerAddress}:${ServerPort}/avi/${avi_id}.avi`;

    return (
        <a  href={url}
            target='_blank'>
            <img src={download}
                    alt="download"
                    width={'30px'}
                    title={statusDetail}
                    className='download'/>
        </a>)
};

const ExportListComponent: React.FC<Props> = ({closeHandler, avilist, direction, setSorting, type, shareStatusHandler}) => {
    const mainRef = useRef<HTMLDivElement>(null);
    const titleRef = useRef<HTMLDivElement>(null);
    const contentRef = useRef<HTMLDivElement>(null);
    const contentTitleRef = useRef<HTMLDivElement>(null);
    const itemsRef = useRef<HTMLDivElement>(null);
    const titleScrollRef = useRef<HTMLDivElement>(null);
    const [refs, setRefs] = useState<ForResizeType[]>([]);
    const { exportWindowSize } = useSelector<ApplicationState, LayoutState>(state => state.layouts);
    const dispatch = useDispatch();
    const { width, height } = exportWindowSize;

    const shareStatus = (avi_id: string) => {
        ServerAddress === 'localhost'
            ?   shareStatusHandler(avi_id)
            :   doCopyText('https://' + ServerAddress + ':' + ServerPort + '/avi/' + avi_id + '.avi')
    };

    const onScrollHandler = (e: any) => {
        if (titleScrollRef.current && contentRef.current) {
            titleScrollRef.current.scrollLeft = contentRef.current.scrollLeft
        }
    }

    const setExportWindowSizeHandler = (w: number, h: number) => {
        const size = {
            width: w,
            height: h
        }
        dispatch(setExportWindowSize(size));
    }

    useEffect(() => {
        setRefs([
                {ref: mainRef, h: true, w: true },
                {ref: contentTitleRef, h: false, w: true}
            ])
    }, []);

    useClickOutside(mainRef, closeHandler);

    return (
        <div className='export-status' ref={mainRef} style={{width: `${width}px`, height: `${height}px`}}>
            <ResizerComponent refs={refs} resizeHandler={setExportWindowSizeHandler} />
                <div className='export-status__title' ref={titleRef}>
                    Exported AVI file
                    <CloseIconComponent handler={closeHandler}/>
                </div>

                <div className='scroll no-scroll-visibility' ref={titleScrollRef}>
                    <ExportListTitleComponent   setSorting={setSorting}
                                                    direction={direction}
                                                    type={type}
                                                    forwardRef={contentTitleRef}
                        />
                </div>
                <div className='export-status__content scroll' ref={contentRef} onScroll={onScrollHandler}>
                    <div className='export-status-content__items'>
                    {
                        avilist.map(({cam_name, avi_id, start_time, creation_time, duration, size, status, completion}) => {
                            return (
                                <div className='flex js-sbw' key={avi_id} ref={itemsRef}>
                                    {/*<div>{cam_name}, {avi_id}, {start_time}, {creation_time}, {duration}, {size}, {status}</div>*/}
                                    <div className={'name export-status-td bold'}><div>{cam_name}</div></div>
                                    <div className={'time export-status-td'}>
                                        <div>{new Date(creation_time).toLocaleDateString()}</div>
                                        {/*<div>{days[new Date(start_time).getDay()]}</div>*/}
                                        <div>{new Date(creation_time).toLocaleTimeString()}</div>
                                    </div>
                                    <div className={'created export-status-td'}>
                                        <div>{new Date(start_time).toLocaleDateString()}</div>
                                        {/*<div>{days[new Date(start_time).getDay()]}</div>*/}
                                        <div>{new Date(start_time).toLocaleTimeString()}</div>
                                    </div>
                                    <div className={'duration export-status-td'}>
                                        <div>{ getTimeDuration( duration) }</div>
                                    </div>
                                    <div className={'size export-status-td'}>
                                        <div>{ getSize(size) }</div>
                                    </div>
                                    <div className={'status export-status-td'}>
                                        { getStatus(completion, avi_id, status) }
                                    </div>
                                    <div className={'share export-status-td'}><div>
                                        <img className='share-icon'
                                             src={shareSrc}
                                             alt="share-icon"
                                             title='Copy AVI URL to Clipboard'
                                             onClick={() => shareStatus(avi_id)}
                                        />
                                    </div></div>
                                </div>
                            )
                        })
                    }
                    </div>
                </div>
        </div>
    )
};

export default ExportListComponent